import React, { useState } from 'react';
import './HeroSection.css';

const HeroSection: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await fetch('https://api.homecookt.com/api/v1/Reguser', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error('Failed to subscribe. Please try again later.');
      }

      setIsSubscribed(true);
      setEmail('');
      setError('');
    } catch (err: any) {
      setError(err.message || 'Something went wrong.');
      setIsSubscribed(false);
    }
  };

  return (
    <section className="hero-container">
      <div className="hero-image" />
      <div className="hero-content">
        <h1 className="hero-title">HomeCookt</h1>
        <p className="hero-subtitle">
          Connecting food lovers with talented home cooks in your neighborhood.
          Subscribe now for early access and priority visibility.
        </p>
        <form className="subscription-form" onSubmit={handleSubmit}>
          <input
            type="email"
            className="email-input"
            placeholder="Enter your email for updates"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="subscribe-button">
            Get Updates
          </button>
        </form>
        {isSubscribed && (
          <div className="success-message">
            Thank you! We'll keep you updated on our launch.
          </div>
        )}
        {error && <div className="error-message">{error}</div>}
      </div>
    </section>
  );
};

export default HeroSection;
